export const BUSINESS_TYPES = [
  { id: 1, label: 'Salón de belleza', icon: '💇' },
  { id: 2, label: 'Barbería', icon: '💈' },
  { id: 3, label: 'Spa', icon: '🧖' },
  { id: 4, label: 'Otro', icon: '✨' },
  { id: 5, label: 'Uñas', icon: '💅' },
  { id: 6, label: 'Estética o cosmetología', icon: '🧴' },
] as const;

export const TOUR_MODULES = [
  'employees',
  'services',
  'products',
  'customers',
  'reservations',
  'pos',
] as const;

export type TourModule = (typeof TOUR_MODULES)[number];

export const TOUR_MODULE_LABELS: Record<TourModule, string> = {
  employees: 'Mi Equipo',
  services: 'Servicios',
  products: 'Productos',
  customers: 'Clientes',
  reservations: 'Agenda',
  pos: 'Caja',
};

// Checklist items: each links to a tour module for guided flow
export const CHECKLIST_ITEMS = [
  {
    key: 'employees' as const,
    label: 'Registra tu primer empleado',
    description: 'Agrega a tu equipo de trabajo',
    route: '/empleados',
    tourModule: 'employees' as TourModule,
  },
  {
    key: 'services' as const,
    label: 'Crea tu primer servicio',
    description: 'Define los servicios que ofreces',
    route: '/servicios',
    tourModule: 'services' as TourModule,
  },
  {
    key: 'products' as const,
    label: 'Registra tu primer producto',
    description: 'Agrega productos a tu inventario',
    route: '/almacen',
    tourModule: 'products' as TourModule,
  },
  {
    key: 'firstSale' as const,
    label: 'Realiza tu primera venta',
    description: 'Completa una venta y llega al momento clave',
    route: '/cajas',
    tourModule: 'pos' as TourModule,
  },
  // 040: activación de facturación electrónica (PSE sin certificado / OSE con
  // certificado). Sin tour asociado: navega directo al asistente.
  {
    key: 'billing' as const,
    label: 'Activa tu facturación electrónica',
    description: 'Emite boletas y facturas SUNAT — sin certificado digital',
    route: '/facturacion/nuevo-ruc',
    tourModule: undefined as unknown as TourModule,
  },
] as const;

// Tours that trigger contextually when user first enters the module (not part of checklist)
export const CONTEXTUAL_TOUR_MODULES: TourModule[] = ['customers', 'reservations'];

// Messages shown when highlighting the next checklist item
export const CHECKLIST_HIGHLIGHT_MESSAGES: Record<string, string> = {
  employees: 'Empieza registrando a tu primer miembro del equipo',
  services: '¡Genial! Ahora crea tu primer servicio',
  products: '¡Excelente! Registra tu primer producto',
  firstSale: '¡Ya casi! Realiza tu primera venta',
  billing: 'Activa tu facturación electrónica para emitir boletas y facturas',
};
